import Vue from 'vue';
import {
    GET_LOGLIST_REQUEST,
    GET_LOGLIST_SUCCESS,
    GET_LOGLIST_FAILURE,
    GET_ORDERLIST_SUCCESS,
    GET_GOODSLIST_SUCCESS,
    GET_ORDERLIST_FAILURE
} from '../mutationTypes';

const tableHeads = [
    // { label: '日志ID', prop: 'id', 'min-width': '100'},
    // { label: '角色', prop: 'role', 'min-width': '100' },
    // { label: '用户名（姓名）', prop: 'name', 'min-width': '120' },
    // { label: '操作内容', prop: 'detail', 'min-width': '300' },
    { label: '操作时间', prop: 'operate_time', 'min-width': '120' },
    { label: 'IP地址', prop: 'ip_addr', 'min-width': '80' }
];

const state = {
    loading: false,
    logList: [],
    orderList:{ // 订单列表
        companyOrder:[],
        personOrder:[]
    },
    goodsList: [],
    pageCount: 0,
    count: 0,
    tableHeads
};

const mutations = {
    [GET_LOGLIST_REQUEST](state) {
        state.loading = true;
    },
    [GET_LOGLIST_SUCCESS](state, res) {
        state.loading = false;
        state.logList = res.list;
        state.pageCount = res.page_count;
        state.count = res.count;
    },
    [GET_ORDERLIST_SUCCESS](state, res) {
        state.orderList = res;
    },
    [GET_GOODSLIST_SUCCESS](state, res) {
        state.goodsList = res;
    },
    [GET_ORDERLIST_FAILURE](state) {
        state.loading = false;
        state.orderList = {
            companyOrder:[],
            personOrder:[]
        };
    },
    [GET_LOGLIST_FAILURE](state) {
        state.loading = false;
        state.logList = [];
        state.pageCount = 0;
        state.count = 0;
    },
};

export const actions = {
    async getLogList({ commit }, params) {
        commit(GET_LOGLIST_REQUEST);
        const res = await Vue.$ajax.get('logList', params);

        if (!res.errorType) {
            commit(GET_LOGLIST_SUCCESS, res);
        } else {
            commit(GET_LOGLIST_FAILURE);
        }
    },
    /**
     * 通过ID 获取 批量完成的信息
     */
    async getLogCompanyList({ commit }, params) {
        const res = await Vue.$ajax.get('getLogCompanyList', params);
        if (!res.errorType) {
            commit(GET_ORDERLIST_SUCCESS, res);
        }
    },

    /**
     * 查看
     */
    async getLogGoods({ commit }, params) {
        const res = await Vue.$ajax.get('getLogGoods', params);
        if (!res.errorType) {
            commit(GET_GOODSLIST_SUCCESS, res);
        }
    }
};

export default {
    state,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/logList.js